import { useTranslation } from 'react-i18next';
import { Popover } from '@c2fo/liquidity';
import { ClockRotateLeftDuotoneIcon, ClockRotateLeftIcon } from '@c2fo/liquidity/icons';
import { TakerMarket } from '@/enterprise/data/useTakerMarkets';
import getRenewalSchedule from '@/utils/getRenewalSchedule';
import { isPreferredOfferNearTermEnd } from '@/utils/preferredOfferRenewal';

interface RenewalRequestIconProps {
  takerMarket: TakerMarket;
  iconStyles?: string;
  iconType?: 'duotone' | 'light';
}

const RenewalRequestIcon = ({ takerMarket, iconStyles, iconType = 'light' }: RenewalRequestIconProps) => {
  const { t } = useTranslation();
  const { hasRenewalSchedule } = getRenewalSchedule(takerMarket);

  if (!isPreferredOfferNearTermEnd(takerMarket) || hasRenewalSchedule) {
    return null;
  }

  const Icon = iconType === 'duotone' ? ClockRotateLeftDuotoneIcon : ClockRotateLeftIcon;

  return (
    <Popover>
      <Popover.Trigger>
        <Icon aria-label={t('preferredRenewalModal.request.action')} className={iconStyles} />
      </Popover.Trigger>
      <Popover.Content arrow className="w-52 text-center" collisionPadding={24} side="bottom" variant="dark">
        <div className="text-sm">{t('taker.termEnd.renewalPopover')}</div>
      </Popover.Content>
    </Popover>
  );
};

export default RenewalRequestIcon;
